/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "Its credential is deleted, and calls through this space stop immediately, together with its project links and tool settings." |
*
* @param {External_Apis_Space_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_delete_description = /** @type {((inputs?: External_Apis_Space_Delete_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Delete_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zugangsdaten werden gelöscht, und Aufrufe über diesen Space enden sofort – mitsamt seinen Projektverknüpfungen und Werkzeug-Einstellungen.")
	return /** @type {LocalizedString} */ ("Its credential is deleted, and calls through this space stop immediately, together with its project links and tool settings.")
});